import React from 'react';
import MarkdownDocPage from '../../components/docs/MarkdownDocPage';
import content from '../../content/sentry-docs/deployment/deploy-wizard.md?raw';

const DeploymentDeployWizard: React.FC = () => {
  return <MarkdownDocPage content={content} />;
};

export default DeploymentDeployWizard;
